<script setup>
const props = defineProps({
  contributors: {
    type: Array,
    required: true,
  },
});

const contributorsWithSocials = props.contributors.filter(contributor => contributor.discord || contributor.linkedIn);
</script>

<template>
  <p
    v-if="contributorsWithSocials.length"
    class="mt-2"
  >
    <span
      v-for="contributor in contributorsWithSocials"
      :key="contributor.gitlabUsername"
    >
      <template v-if="contributor.linkedIn && contributor.discord">
        Connect with {{ contributor.name }} on
        <a
          :href="contributor.linkedIn"
          target="_blank"
        >LinkedIn</a>, or find them as
        <code>{{ contributor.discord }}</code> on
        <a
          href="https://discord.gg/gitlab"
          target="_blank"
        >Discord</a>.
      </template>
      <template v-else-if="contributor.linkedIn">
        Connect with {{ contributor.name }} on
        <a
          :href="contributor.linkedIn"
          target="_blank"
        >LinkedIn</a>.
      </template>
      <template v-else-if="contributor.discord">
        Find {{ contributor.name }} as
        <code>{{ contributor.discord }}</code> on
        <a
          href="https://discord.gg/gitlab"
          target="_blank"
        >Discord</a>.
      </template>
    </span>
  </p>
</template>
